import * as Yup from 'yup'

export const ForgotPasswordNewSchema = Yup.object().shape({
  email: Yup.string()
    .email('Por favor informe um e-mail válido.')
    .required('O email é obrigatório.'),
})
